import type { GenerateFunction } from "./ai-complexity.js";

export interface OllamaOptions {
  url?: string;
  model?: string;
}

function resolveOllamaUrl(url?: string): string {
  return url
    ?? process.env.FATHOM_OLLAMA_URL
    ?? process.env.OLLAMA_API_URL
    ?? "http://localhost:11434";
}

export function createOllamaGenerator(options: OllamaOptions = {}): GenerateFunction {
  const baseUrl = resolveOllamaUrl(options.url);
  const model = options.model ?? "qwen2.5-coder";

  return async (systemPrompt: string, userPrompt: string): Promise<string> => {
    const response = await fetch(`${baseUrl}/api/chat`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        model,
        messages: [
          { role: "system", content: systemPrompt },
          { role: "user", content: userPrompt },
        ],
        stream: false,
      }),
    });

    if (!response.ok) {
      throw new Error(`Ollama request failed: ${response.status} ${response.statusText}`);
    }

    const data = (await response.json()) as { message?: { content?: string } };
    return data.message?.content ?? "";
  };
}

export async function isOllamaAvailable(url?: string): Promise<boolean> {
  try {
    const baseUrl = resolveOllamaUrl(url);
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 2000);
    const res = await fetch(`${baseUrl}/api/tags`, {
      method: "HEAD",
      signal: controller.signal,
    });
    clearTimeout(timeout);
    return res.ok;
  } catch {
    return false;
  }
}
